/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VariantInfo
 */
export interface VariantInfo {
    /**
     * 
     * @type {string}
     * @memberof VariantInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VariantInfo
     */
    unit?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantInfo
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof VariantInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantInfo
     */
    parentId?: string;
}

/**
 * Check if a given object implements the VariantInfo interface.
 */
export function instanceOfVariantInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function VariantInfoFromJSON(json: any): VariantInfo {
    return VariantInfoFromJSONTyped(json, false);
}

export function VariantInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'quantity': json['quantity'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
    };
}

export function VariantInfoToJSON(value?: VariantInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'unit': value.unit,
        'quantity': value.quantity,
        'id': value.id,
        'parentId': value.parentId,
    };
}

